import type { FathomSummary } from './types';

export function serializeFathomSummary(summary: FathomSummary): any {
  return {
    url: summary.url,
    summary: summary.summary ?? null,
    candidate_todos: (summary.candidateTasks ?? []).map((candidate) => ({
      id: candidate.id,
      title: candidate.title,
      status: candidate.status,
      decided_by_user_id: candidate.decidedByUserId ?? null,
      decided_at: candidate.decidedAt ?? null,
      accepted_todo_id: candidate.acceptedTaskId ?? null,
      matched_todo_id: candidate.matchedTaskId ?? null,
      matched_todo_title: candidate.matchedTaskTitle ?? null,
      assignee_name: candidate.assigneeName ?? null,
      assignee_email: candidate.assigneeEmail ?? null,
    })),
    attached_at: summary.attachedAt,
    attached_by_user_id: summary.attachedByUserId ?? null,
    source: summary.source,
  };
}

export function serializeFathomSummaries(summaries: FathomSummary[]): any {
  return summaries.map(serializeFathomSummary);
}
